import React, { useMemo, useCallback } from 'react';

import { Grid, Button } from '@gogame/components';
import {
  withArrayFormField,
  FormFieldGroup,
  useFormContext,
} from '@gogame/form';
import { useSourceCache } from '@gogame/hooks-ts';
import { dateFNS } from '@gogame/intl-ts';

import { loadUsers } from 'scenes/Campaigns/sources/fields';

import { OWNER_ID, PERIOD_START_DATE } from '../constants';
import { createNewOwner } from '../schema';
import OwnerItem from './OwnerItem';
import { OWNER } from 'scenes/Campaigns/components/Form/constants';

const EMPTY_VALUE = [];

export const Owners = withArrayFormField()(({
  value = EMPTY_VALUE,
  name,
  push,
  remove,
}) => {
  const { values } = useFormContext();
  const currentOwner = values[OWNER];
  const lastOwner = useMemo(() => [...value].pop(), [value]);
  const handleChangeOwner = useCallback(() => {
    const lastPeriodDate = lastOwner?.[PERIOD_START_DATE];
    push(createNewOwner(lastPeriodDate));
  }, [push, lastOwner]);

  const handleLoadOwners = useSourceCache(loadUsers);

  return (
    <Grid container spacing={3}>
      {value.map((current, i) => {
        const prev = value[i - 1];
        const next = value[i + 1];
        const min = prev
          ? dateFNS.addDays(new Date(prev[PERIOD_START_DATE]), 1)
          : undefined;
        const max = next
          ? dateFNS.subDays(new Date(next[PERIOD_START_DATE]), 1)
          : dateFNS.startOfToday();

        const path = `${name}[${i}]`;
        const isCurrentUser = currentOwner === current[OWNER_ID];
        const isFirst = i === 0;
        return (
          <Grid item xs={12}>
            <FormFieldGroup name={path} key={path}>
              <OwnerItem
                index={i}
                onRemove={() => remove(i)}
                max={max}
                min={min}
                isCurrentOwner={isCurrentUser}
                isFirst={isFirst}
                onLoadOwners={handleLoadOwners}
              />
            </FormFieldGroup>
          </Grid>
        );
      })}
      <Grid item xs={12}>
        <Button variant={'outlined'} onClick={handleChangeOwner} add={true}>
          Owner
        </Button>
      </Grid>
    </Grid>
  );
});
